// 定义一组马卡龙色
const macaronColors = ["#f5bdcc", "#A1EAFB", "#FFC3A0", "#80acee", "#c0ec74", "#f18575"];

// const DarkColors = [
//   "#7c0303", // 红色
//   "#097e09", // 绿色
//   "#06067c", // 蓝色
//   "#880888", // 紫色
//   "#037777", // 青色
//   "#a95e11", // 橙色
// ];

// 创建一个函数来随机选择一个颜色
export default function getRandomColor(key) {
  const colorArray = macaronColors;
  const randomIndex = Math.floor(Math.random() * colorArray.length);
  if (key === "up") {
    return "#74b6ec";
  }
  if (key === "down") {
    return "#f18575";
  }
  if (key === "good") {
    return "#9ee388";
  }
  if (key === "bad") {
    return "#cc9d71";
  }

  return colorArray[randomIndex];
}
